







































































import { Vue, Component, Prop, Mixins } from "vue-property-decorator";
import PageSection from "@/components/PageSection.vue";
import ClientsMixin from "@/mixins/http/ClientsMixin";
import Page from "@/views/Page.vue";
import { RegisterHttp } from "../../utils/Decorators";
import RequestData from "../../store/types/RequestData";
import SectionField from "@/components/SectionField.vue";
import { currentUserStore } from "@/store/typed";

import { showToast } from "../../utils/Toast";
import WithErrors from "@/directives/WithErrors";
import { ClientPayload } from "../../models/Client";

const tag = "edit_client";
const getTag = "get_client";

@Component({
  directives: {
    WithErrors,
  },
  components: {
    PageSection,
    Page,
    SectionField,
  },
})
export default class ClientEdit extends Mixins(ClientsMixin) {
  @RegisterHttp(tag) readonly editClientRequest: RequestData;
  @RegisterHttp(getTag) readonly getClientRequest: RequestData;

  client: ClientPayload = null;

  get loading() {
    return this.editClientRequest?.loading;
  }

  get currentUser() {
    return currentUserStore.currentUser;
  }

  get companyId() {
    return this.currentUser?.company?.id;
  }

  get id() {
    return this.$route.params.id;
  }

  get requestTag() {
    return tag;
  }

  async load() {
    const client = await this.getClient(this.id, this.companyId, getTag);
    this.client = ClientPayload.fromClient(client);
    this.client.companyId = this.companyId;
  }

  back() {
    this.$router.go(-1);
  }

  onCreate() {
    this.updateClient(this.client.id, this.client, tag).then(
      (resp) => {
        showToast("Client updated successfully");
        this.back();
      },
      (err) => {
        showToast("An error occurred while updating the client", {
          type: "error",
        });
      }
    );
  }

  mounted() {
    this.load();
  }
}
